import { chartTheme, getSeriesColor } from './chartTheme';

/**
 * Build stable SVG linearGradient ids + defs for area series fills.
 */
export function buildAreaGradientDefs(series = [], instanceId = 'chart') {
  return series.map((item, index) => {
    const stroke = getSeriesColor(index, item.stroke || item.color);
    const key = item.dataKey || item.name || `series-${index}`;
    const id = `y-area-grad-${instanceId}-${String(key).replace(/\W+/g, '-')}`;
    const topOpacity = item.fillOpacityTop ?? chartTheme.areaFillTop;
    return {
      id,
      stroke,
      key,
      topOpacity,
      bottomOpacity: item.fillOpacityBottom ?? chartTheme.areaFillBottom
    };
  });
}
